import { CareerType } from '../enum/EnumRepository';

const PREFERRED_CAREER_SECTION_ORDER: readonly CareerType[] = [
  CareerType.EDU,
  CareerType.WRT,
  CareerType.CNS,
  CareerType.S_EXH,
  CareerType.G_EXH,
  CareerType.BIEN_TRIEN,
  CareerType.PRJ,
  CareerType.FAR,
  CareerType.AWD_GRT,
  CareerType.PRS,
  CareerType.RSD,
  CareerType.RPS,
  CareerType.EXP,
  CareerType.TCH,
  CareerType.RSH,
  CareerType.PBL,
  CareerType.COL,
];

const CAREER_TYPES = Object.values(CareerType) as CareerType[];
const CAREER_TYPE_SET = new Set<string>(CAREER_TYPES);

/** 새 CareerType은 기존 순서를 깨지 않고 뒤에 자동 추가한다. */
export const DEFAULT_CAREER_SECTION_ORDER: readonly CareerType[] = [
  ...PREFERRED_CAREER_SECTION_ORDER,
  ...CAREER_TYPES.filter((type) => !PREFERRED_CAREER_SECTION_ORDER.includes(type)),
];

/** 중복·알 수 없는 값을 제거하고 빠진 CareerType을 기본 순서로 보충한다. */
export const normalizeCareerSectionOrder = (
  order: readonly unknown[] | null | undefined,
): CareerType[] => {
  const normalized: CareerType[] = [];
  const seen = new Set<CareerType>();

  for (const value of order ?? []) {
    if (typeof value !== 'string' || !CAREER_TYPE_SET.has(value)) continue;
    const careerType = value as CareerType;
    if (seen.has(careerType)) continue;
    seen.add(careerType);
    normalized.push(careerType);
  }

  for (const careerType of DEFAULT_CAREER_SECTION_ORDER) {
    if (seen.has(careerType)) continue;
    seen.add(careerType);
    normalized.push(careerType);
  }

  return normalized;
};

/** 드래그한 활성 섹션만 기존 활성 슬롯에 치환해 빈 섹션 위치를 보존한다. */
export const mergeActiveCareerSectionOrder = (
  fullOrder: readonly unknown[] | null | undefined,
  reorderedActiveTypes: readonly CareerType[],
): CareerType[] => {
  const normalizedFullOrder = normalizeCareerSectionOrder(fullOrder);
  const activeTypes = new Set(reorderedActiveTypes);
  let activeIndex = 0;

  return normalizedFullOrder.map((type) => {
    if (!activeTypes.has(type)) return type;
    const reorderedType = reorderedActiveTypes[activeIndex];
    activeIndex += 1;
    return reorderedType ?? type;
  });
};
